module.exports = __webpack_public_path__ + "img/ganglioncyst_1.4e5eeaaf.gif";